import { useEffect, useRef } from 'react';

export const useEffectOnValueChange = (
  effect: Parameters<typeof useEffect>[0],
  deps: Parameters<typeof useEffect>[1],
) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    return effect();
  }, deps);
};
